import { Box, Button, IconButton, Tooltip } from "@mui/material";
import Datatable from "../../../components/features/Datatable";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import {
    deletePrintDetails,
    disableAddModal,
    enableAddModal,
    fetchAllPrintDetails,
    selectBmrAddPrintDetailsModal,
    selectPrintDetailsAll,
    selectPrintDetailsLoading
} from "../../../slices/printDetails";
import PrintDetailsForm from "./PrintDetailsForm";
import { truncateText } from '../../../../utils/utils'
import { labelTypeList } from '../../../utils/common/utils'

const PrintDetails = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectPrintDetailsLoading);
    const addModal = useSelector(selectBmrAddPrintDetailsModal);
    const allPrintDetails = useSelector(selectPrintDetailsAll);
    const [rowData, setRowData] = useState(null);
    const [open, setOpen] = useState(false);


    // ✅ Columns for DataTable
    const columns = [
        {
            id: 'products_id',
            name: 'Products Name',
            align: "center",
            selector: row => {
                    const fullText = row?.products?.map(p => p.product?.name)?.join(", ") || "-";
                    return (
                        <Tooltip title={fullText}>
                            <span>{truncateText(fullText, 50)}</span>
                        </Tooltip>
                    );
                },
                sortable: true
        },
        {
            id: 'brand_name',
            name: 'Brand Name',
            align: "center",
            selector: row => row.brand_name,
            sortable: true
        },
         /*{
            id: 'brand_description',
            name: 'Brand Description',
            align: "center",
            selector: row => {
                    return (
                        <Tooltip title={row?.brand_description}>
                            <span>{truncateText(row?.brand_description, 150)}</span>
                        </Tooltip>
                    );
            },
            sortable: true
        },*/
        {
            id: 'organisation_name',
            name: 'Organisation Name',
            align: "center",
            selector: row => row?.organisation_name,
            sortable: true
        },
        {
            id: 'label_type',
            name: 'Label Type',
            align: "center",
            selector: row => {
                const labelTypes = row?.label_types;
                if (!labelTypes) return '--';
                const labels = labelTypes?.map(type => {
                        const found = labelTypeList.find(item => 
                            String(item.value) === String(type)
                        );
                        return found ? found.label : null;
                    })
                    .filter(label => label !== null); // Remove null values
                    const lab = labels.length > 0 ? labels.join(', ') : '--'
                return  <Tooltip title={lab}>{lab}</Tooltip>
            },
            sortable: true,
        },
         {
            id: 'org_description',
            name: 'Address',
            align: "center",
            selector: row => {
                return (
                    <Tooltip title={row?.org_description}>
                        <span>{truncateText(row?.org_description, 150)}</span>
                    </Tooltip>
                );
            },
            sortable: true
        },
        {
            id: 'brand_logo_id',
            name: 'Brand Logo',
            align: "center",
            selector: row => (
                <a href={row?.brand_logo?.file_path} target="blank">{row?.brand_logo?.file_path ? <img width={'50px'} src={row?.brand_logo?.file_path} />:'-'}</a>
            ),
            sortable: true
        },
        {
            id: 'organisation_logo_id',
            name: 'Organisation Logo',
            align: "center",
            selector: row => (
                <a href={row.organisation_logo?.file_path} target="blank">{row.organisation_logo?.file_path ? <img width={'50px'} src={row?.organisation_logo?.file_path} /> :"-"}</a>
            ),
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => (
                <Box key={row.id}>
                    <Tooltip title="Edit">
                        <span>
                            <IconButton
                                onClick={() => {
                                    setRowData(row);
                                    handleAddModal();
                                }}
                            >
                                <EditIconButton bgColor={"#C3C3C3"} />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <span>
                            <IconButton
                                onClick={() => {
                                    setRowData(row);
                                    setOpen(true);
                                }}
                            >
                                <DeleteIconButton bgColor={"#FA5151"} />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            ),
        },
    ];

    // ✅ Fetch all data
    const fetchData = async () => {
        await dispatch(disableAddModal());
        await dispatch(fetchAllPrintDetails());
    };

    useEffect(() => {
        fetchData();
    }, []);

    // ✅ Modal handlers
    const handleCloseModal = async () => {
        await dispatch(disableAddModal());
    };

    const handleAddModal = async () => {
        await dispatch(enableAddModal());
    };

    // ✅ Delete handler
    const removePrintDetails = async () => {
        const { id } = rowData;
        await dispatch(deletePrintDetails({ id }));
        setOpen(false);
    };

    return (
        <div className="!p-6">
            <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
                {/* Add / Edit Modal */}
                <BsModal
                    open={addModal}
                    onClose={handleCloseModal}
                    title={rowData ? "Edit Print Details" : "Add Print Details"}
                >
                    <PrintDetailsForm editData={rowData} />
                </BsModal>

                {/* Datatable */}
                <Datatable
                    columns={columns}
                    data={allPrintDetails}
                    title="Print Details"
                    searchPlaceholder="Search by Brand or Organisation"
                    loading={isLoading}
                    BtnComponent={
                        <Button
                            className="ml-2"
                            onClick={() => {
                                handleAddModal();
                                setRowData(null);
                            }}
                        >
                            Add New
                        </Button>
                    }
                />

                {/* Delete Confirmation Modal */}
                <DeleteModal
                    open={open}
                    setClose={setOpen}
                    title={"Are you sure you want to delete this Print Details entry?"}
                    buttonText={"Delete"}
                    handleSuccess={removePrintDetails}
                />
            </div>
        </div>
    );
};

export default PrintDetails;
